<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="showButtonOrdemServico",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro"
    :infoPrazos="showInfoVencimento() && infoPrazos"
    @atualizarFiltro="atualizarFiltro"
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="CRIAR_ORDEM_SERVICO",
    @selectItem="SELECIONA_PROCESSO"
  )
  span.padding-left(v-if="showButtonOrdemServico") {{ 'Processos Selecionados: ' + idsProcessos.length }}
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import AppListagem from '@/components/AppListagem.vue'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalAvocar from '@/screens/analise/components/modal/AppModalAvocar'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel'
import AppModalAssinarTitulo from '@/screens/analise/components/AppModalAssinarTitulo'
import AppModalSolicitarRetificacao from '@/screens/analise/components/modal/AppModalSolicitarRetificacao'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    if (to.name !== 'ordem-servico') {
      this.setProcessoSelecionados({ processos: [], map: true })
    }
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    AppModalAvocar,
    ModalTrocarResponsavel,
    AppModalAssinarTitulo,
    AppModalSolicitarRetificacao
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('AGUARDANDO_INDEFERIMENTO'),
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      setoresInfoVencimento: [ 'GAC', 'GEO', 'GCG', 'CGIR', 'DEAF', 'GDA', 'GRF', 'GAM', 'GEA', 'DJ', 'CDI', 'CPAV', 'GP', 'GIT', 'GRF_CAF',
        'GCG_CGIR'],
      processosSelecionados: [],
      showModalResponsavel: false,
      disabledAnalisar: false,
      showModalVisualizarProcesso: false,
      solicitarRetificacao: false,
      showModalAssinatura: false,
      showModalAvocar: false,
      processoTrocado: null,
      idProcesso: null,
      numeroProcesso: null,
      tipoProcesso: null,
      setorSelecionado: null,
      protocolo: null,
      idsProcessosAssinatura: [],
      idsProcessos: [],
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.CAIXA_ENTRADA || [],
        filtroResponsavel: filtro?.filtroResponsavel?.CAIXA_ENTRADA || [],
        filtroMunicipio: filtro?.filtroMunicipio?.CAIXA_ENTRADA || [],
        filtroOrdemServico: [],
        filtroFuncao: [],
        filtroDataVencimento: [],
        filtroRua: [],
        filtroBairro: [],
        filtroRemessa: [],
        filtroQuadra: [],
        filtroOS: []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [], exibir: () => this.showColuna('filtroSituacao') },
        { id: 4, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [] },
        { id: 5, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 6, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 7, titulo: 'Responsável', propriedade: 'responsavel', ordem: 5, acoes: [], exibir: () => this.showColuna('filtroResponsavel') },
        { id: 8, titulo: 'Ordem de Serviço', propriedade: 'numeroOs', ordem: 5, acoes: [], exibir: () => this.showColuna('filtroOrdemServico') },
        { id: 9, titulo: 'Função', propriedade: 'funcoes', ordem: 5, acoes: [], exibir: () => this.showColuna('filtroFuncao') },
        { id: 10, titulo: 'Data de vencimento', propriedade: 'dataVencimento', ordem: 5, acoes: [], isPrazo: true, exibir: () => this.showInfoVencimento() },
        {
          id: 11, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso }
          ]
        }
      ],

      usuario: null,
      filtroRapido: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.usuario = await this.usuarioLogado
  },

  beforeDestroy () {
    this.ordemServicoClear()
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    }),
    ...mapState({
      listaProcessosAuxiliar: state => state.ordemServico.listaProcessosAuxiliar
    }),
    showButtonOrdemServico () {
      return false
    }
  },

  methods: {

    ...mapActions({
      ordemServicoClear: 'ordemServico/clear',
      setListaProcessoAuxiliar: 'ordemServico/setListaProcessoAuxiliar',
      retornarSetor: 'processo/retornarSetor',
      setProcessoSelecionados: 'ordemServico/setProcessoSelecionados',
      getPvtnAtivo: 'vtn/getPvtnAtivo',
      getProcessoByProtocolo: 'processos/getProcessoByProtocolo'
    }),

    showColuna (coluna) {
      return this.configuracaoFiltro[coluna].find(perfil => perfil === this.usuario?.perfilSelecionado?.codigo)
    },

    showInfoVencimento () {
      return !!this.setoresInfoVencimento.find(setor => setor === this.usuario?.perfilSelecionado?.setor?.codigo)
    },

    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}

.padding-left {
  padding-left: 25px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaAguardandoRespostaIndeferimento.vue